import { useRef } from "react";

export function useArrayMemo<T extends unknown[] | readonly unknown[]>(
  items: T,
): T {
  const ref = useRef<T>(items);

  if (
    ref.current.length !== items.length ||
    !items.every((item, index) => item === ref.current[index])
  ) {
    ref.current = items;
  }

  return ref.current;
}
